import React from 'react';
import { Tag, Tooltip } from 'antd';
import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  CloseCircleFilled,
  QuestionCircleFilled,
} from '@ant-design/icons';
import useTenantFlags from 'hooks/useTenantFlags';

// Semáforo de cumplimiento regulatorio MINVU.
// Acepta la convención Fase 3 (ok/warning/critical/unknown) y la oficial de
// Fase 5 del backend (verde/amarillo/rojo/sin_datos). Ambas se normalizan al
// mismo CONFIG interno para consistencia visual.
//
// Props:
// - status: 'ok'|'warning'|'critical'|'unknown'|'verde'|'amarillo'|'rojo'|'sin_datos'
// - score: número opcional 0-100. Si se provee, se renderiza como sufijo.
// - label: override del label default
// - tooltip: texto del Tooltip
// - size: 'sm' | 'md' (default 'md')

const STATUS_ALIASES = {
  ok: 'ok',
  verde: 'ok',
  warning: 'warning',
  amarillo: 'warning',
  critical: 'critical',
  rojo: 'critical',
  unknown: 'unknown',
  sin_datos: 'unknown',
};

const CONFIG = {
  ok: { color: 'green', icon: <CheckCircleFilled />, label: 'Al día' },
  warning: { color: 'orange', icon: <ExclamationCircleFilled />, label: 'Atención' },
  critical: { color: 'red', icon: <CloseCircleFilled />, label: 'Crítico' },
  unknown: { color: 'default', icon: <QuestionCircleFilled />, label: 'Sin datos' },
};

function ComplianceBadge({ status = 'unknown', score, label, tooltip, size = 'md' }) {
  const { minvuEnabled } = useTenantFlags();
  if (!minvuEnabled) return null;

  const normalized = STATUS_ALIASES[status] ?? 'unknown';
  const config = CONFIG[normalized];
  const finalLabel =
    label ?? (typeof score === 'number' ? `${config.label} · ${score}%` : config.label);
  const tag = (
    <Tag
      color={config.color}
      icon={config.icon}
      style={{
        margin: 0,
        fontSize: size === 'sm' ? 11 : 12,
        fontWeight: 600,
        padding: size === 'sm' ? '1px 8px' : '2px 10px',
      }}
    >
      {finalLabel}
    </Tag>
  );

  return tooltip ? <Tooltip title={tooltip}>{tag}</Tooltip> : tag;
}

export default ComplianceBadge;
